import { render, staticRenderFns } from "./Profile-Blocked-Users.vue?vue&type=template&id=2593d448&scoped=true&"
import script from "./Profile-Blocked-Users.vue?vue&type=script&lang=js&"
export * from "./Profile-Blocked-Users.vue?vue&type=script&lang=js&"
import style0 from "./Profile-Blocked-Users.vue?vue&type=style&index=0&id=2593d448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2593d448",
  null
  
)

export default component.exports